import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const metricsSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'metricConnectedViewName': {
    id: 'metricConnectedViewName',
    getMenuItemDisplayValue: Messages.column_metrics_viewName,
    subSortOptions: {
      'asc': {
        id: 'metricConnectedViewName.asc',
        field: OrderKeys.metricConnectedViewName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByViewAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.metricConnectedViewName)]
      },
      'desc': {
        id: 'metricConnectedViewName.desc',
        field: OrderKeys.metricConnectedViewName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByViewDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.metricConnectedViewName)]
      }
    }
  },
  'project': SortOptions.projectName,
  'owner': {
    id: 'owner',
    getMenuItemDisplayValue: Messages.column_owner,
    subSortOptions: {
      'asc': {
        id: 'owner.asc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByOwnerAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.ownerName)]
      },
      'desc': {
        id: 'owner.desc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByOwnerDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.ownerName)]
      }
    }
  },
  'modified': SortOptions.updated,
  /*TFSID:1023577 'hits': SortOptions.hits, */
};
